import ChooseRoleContainer from 'containers/ChooseRoleContainer'
import React from 'react'

const ChooseRole = () => <ChooseRoleContainer />

export default ChooseRole
